module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/no2-69f8340cc72c86a81937deb7429c18dc.png";